export const formatArray = (array: any[] | undefined) => {
  if (array) {
    return array.join(",");
  }
  return array;
};
